/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';

import moment from 'utils/moment';
import styles from '../../../../styles/general.module.scss';

const quarters = {
  1: 'Q1',
  2: 'Q2',
  3: 'Q3',
  4: 'Q4'
};
const Table = ({ info, user }) => {
  const dateFormat = localStorage.getItem('dateFormat') || 'MM/DD/YYYY';
  const timeFormat = localStorage.getItem('timeFormat') || 'hh:mm A';
  const dateTimeFormat = `${dateFormat} ${timeFormat}`;

  return (
  <table className={styles.table}>
    <thead>
      <tr>
        <th>
          <FormattedMessage id="workorder.detail.request.logged_by" defaultMessage="Logged by" />
        </th>
        <th>
          <FormattedMessage id="workorders.list.table.reported.date" defaultMessage="Reported Date" />
        </th>
        <th>
          <FormattedMessage id="workorders.list.table.categorry" defaultMessage="Time Period" />
        </th>
        <th>
        <FormattedMessage id="lease.tenants.steps.step3.aggrement" defaultMessage="Agreement" />
        </th>
        <th>
          <FormattedMessage id="lease.tenants.steps.step3.amorunt" defaultMessage="Total Gross Sales" />
        </th>
        <th>
          <FormattedMessage id="lease.tenants.steps.step3.ass" defaultMessage="Total Rent Due" />
        </th>
        <th>
          {''}
        </th>
      </tr>
    </thead>
    <tbody>
    {info.map(e => (
      <tr key={e.id}>
        <td>
          {e?.logged_by?.fullname}
        </td>
        <td className={styles.date}>{(moment(e.report_date)).format(dateTimeFormat)}</td>
        <td>{`${e.month}-${quarters[e.quarter]}-${moment(e.year).format('YYYY')}`}</td>
        <td>
          {e?.contract?.contract_name}{e?.status === 0
                && <span style={{ background: '#9B9B9B',
                                  padding: '2px 10px',
                                  fontSize: '12px',
                                  borderRadius: '13px',
                                  color: 'white',
                                  margin: '0 0 0 5px'
                                }}
                      >
                        <FormattedMessage id="inspections.step0.draft" defaultMessage="Draft" />
                   </span>
                }
        </td>
        <td>
        <NumberFormat displayType="text"
          value={e?.total_gross_sales}
          thousandSeparator
          decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
          fixedDecimalScale
          prefix={user?.urls?.currency || '$'}
                />
        </td>
        <td>
        <NumberFormat displayType="text"
          value={e?.total_rent_due}
          thousandSeparator
          decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
          fixedDecimalScale
          prefix={user?.urls?.currency || '$'}
                />
        </td>
        <td>
        <Link to={`/gross_receipts/${e.id}/${e?.status === 0 ? 'edit': 'detail'}`}>
          <FormattedMessage
            id="workorders.list.table.action"
            defaultMessage="View"
          />
        </Link>
        </td>
      </tr>
      ))
    }
    </tbody>
  </table>
  );
};

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
